export default "__VITE_ASSET__BLk91yQ5__"